export const INQUIRY_STATUS = {
  new: { label: "待处理", tone: "neutral" },
  ai_queued: { label: "AI 排队中", tone: "info" },
  translating: { label: "中文翻译中", tone: "info" },
  researching: { label: "AI 背调中", tone: "info" },
  generating_reply: { label: "回复生成中", tone: "info" },
  send_queued: { label: "等待发送", tone: "info" },
  sending: { label: "邮件发送中", tone: "warning" },
  pending_review: { label: "待审核", tone: "warning" },
  replied: { label: "已回复", tone: "success" },
  ignored: { label: "无需回复", tone: "neutral" },
  failed: { label: "处理失败", tone: "danger" },
};

export const PROCESSING_STATUSES = new Set([
  "ai_queued",
  "translating",
  "researching",
  "generating_reply",
  "send_queued",
  "sending",
]);

export const FOLLOW_UP_STATUS = {
  new: "未跟进",
  contacted: "已联系",
  waiting_customer: "等待客户回复",
  follow_up_due: "需要跟进",
  won: "已成交",
  closed: "已关闭",
};

export const getStatus = (status, fallback) =>
  INQUIRY_STATUS[status] || { label: fallback || status || "未知", tone: "neutral" };
